<div class="row">
  <div class="header-tab">
    <div class="row flex-left">
      <li
        v-for="tab in tabs"
        @click="setActiveTab(tab)"
        :class="{ 'active': (tab?.val === active || tab === active) }"
      >
        {{ isTranslate ? $t(tab?.label || tab || "undefined") : tab?.label || tab || "undefined" }}
      </li>
    </div>
    <!-- <div class="row flex-right">...</div> -->
  </div>
</div>
